<p class="prf-footer-navigation-title">{{ legal.title }}</p>
<ul class="prf-footer-navigation">
  @for (link of legal.links; track link.id) {
    <li class="prf-footer-navigation-item">
      <a [href]="link.href" target="_blank" rel="noopener noreferrer">{{ link.linkText }}</a>
    </li>
  }
</ul>
